import React, { Component } from "react";
import moment from "moment";

export class EachFeedback extends Component {
  render() {
    const { feedbacks } = this.props;
    return (
      <div className="container">
        {feedbacks &&
          feedbacks.map((feedback) => {
            return (
              <div className="card m-3 container">
                <p className="mb-1 mt-2">Email: {feedback.email}</p>
                <p className="mb-1 mt-1">Subject: {feedback.subject}</p>
                <p className="mb-1 mt-1">Message: {feedback.message}</p>
                <p className="mb-1 mt-1">
                  Date: {moment(feedback.date).format("DD MM YYYY hh:mm")}
                </p>
              </div>
            );
          })}
      </div>
    );
  }
}

export default EachFeedback;
